import React from "react";
import MegaMenu from "./MegaMenu";

// Existing component entry point retained for homepage imports.
export default function SolutionDropdown() {
  return <MegaMenu kind="solutions" />;
}
